import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

import getFetchOptions from '../utils/getFetchOptions';

export default function deleteClassMembers(extractedIds, subsId) {
	return fetch(
		`${ENDPOINT_URL}/adminclass/deleteclass`,
		getFetchOptions({
			method: 'DELETE',
			body: JSON.stringify({
				extractedIds,
				subsId,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
